// Generated by scripts/generate-browser-seo.js. Do not edit directly.
const SITE_URL = 'https://deroyaltycarrental.com';
const SITE_NAME = 'DeRoyalty Car Rental';
const DEFAULT_IMAGE_PATH = '/web-logo.jpg';
const INSTAGRAM_URL = 'https://www.instagram.com/royaltycarsrental';

const STATIC_PAGE_METADATA = {
  '/home': {
    title: 'Car Rental in Harare, Zimbabwe | DeRoyalty',
    description: 'Book reliable hatchback, sedan, SUV, executive, off-road and twin-cab car rental in Harare, Zimbabwe, with DeRoyalty Car Rental.',
    breadcrumb: 'Home',
  },
  '/about': {
    title: 'About DeRoyalty Car Rental | Harare, Zimbabwe',
    description: 'Meet DeRoyalty Car Rental and learn about our premium fleet standards, hospitality-led service and growing international footprint.',
    breadcrumb: 'About Us',
  },
  '/contact': {
    title: 'Contact DeRoyalty Car Rental | Harare',
    description: 'Contact DeRoyalty Car Rental in Waterfalls, Harare, for reservations, vehicle hire support, airport pickup enquiries and rental assistance.',
    breadcrumb: 'Contact Us',
  },
  '/quote': {
    title: 'Request a Car Rental Quote | DeRoyalty Harare',
    description: 'Request a tailored DeRoyalty vehicle rental quote for your route, dates, preferred vehicle and pickup or drop-off requirements.',
    breadcrumb: 'Request a Quote',
  },
  '/meet-the-team': {
    title: 'Meet the DeRoyalty Team | Car Rental Specialists',
    description: 'Meet the people behind DeRoyalty Car Rental and our client-focused vehicle hire service in Zimbabwe and beyond.',
    breadcrumb: 'Meet the Team',
  },
  '/lease-your-vehicle': {
    title: 'Lease Your Vehicle to DeRoyalty | Harare',
    description: 'Enquire about placing your suitable vehicle with DeRoyalty Car Rental for professional fleet evaluation and lease consideration.',
    breadcrumb: 'Lease Your Vehicle',
  },
  '/vehicles': {
    title: 'Car Hire Fleet in Harare | DeRoyalty Vehicles',
    description: 'Explore DeRoyalty car hire options in Harare, including economy cars, sedans, SUVs, executive vehicles, twin cabs and off-road vehicles.',
    breadcrumb: 'Vehicles',
  },
  '/terms-and-conditions': {
    title: 'Rental Terms and Conditions | DeRoyalty Car Rental',
    description: 'Read the terms and conditions that apply to DeRoyalty vehicle rentals, bookings, driver requirements, payments and vehicle use.',
    breadcrumb: 'Terms and Conditions',
  },
};

const NOINDEX_PREFIXES = [
  '/admin',
  '/auth',
  '/booking',
  '/cart',
  '/checkout',
  '/dashboard',
  '/payment',
  '/wishlist',
];

const ABOUT_FAQS = [
  {
    question: 'What makes DeRoyalty different?',
    answer: 'We combine premium fleet standards, reliable branch support and a hospitality-led service model for clients who expect a refined rental experience.',
  },
  {
    question: 'Where does DeRoyalty operate?',
    answer: 'Our current footprint includes Zimbabwe, South Africa, Angola, the United Kingdom, the United Arab Emirates and Australia.',
  },
  {
    question: 'Can DeRoyalty support business and leisure travel?',
    answer: 'Yes. Our service approach is built for executive movement, airport transfers, city travel, family trips and high-comfort road journeys.',
  },
];

function normalizePathname(pathname = '/') {
  const withoutQuery = String(pathname).split(/[?#]/, 1)[0] || '/';
  const withLeadingSlash = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;
  if (withLeadingSlash === '/') return '/';
  return withLeadingSlash.replace(/\/+$/, '');
}

function absoluteUrl(pathOrUrl = '/') {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const normalized = String(pathOrUrl).startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${SITE_URL}${normalized}`;
}

function canonicalVehiclePath(product) {
  return `/vehicle/show/${product.id}/${encodeURIComponent(product.name || 'vehicle')}`;
}

function findProduct(products, id) {
  return (Array.isArray(products) ? products : []).find(
    (product) => String(product?.id) === String(id),
  );
}

function findCategory(categories, id) {
  return (Array.isArray(categories) ? categories : []).find(
    (category) => String(category?.id) === String(id),
  );
}

function getCategoryName(category) {
  return category?.categoryName || category?.category_name || category?.name || '';
}

function buildBasePage(pathname, metadata) {
  const canonicalPath = pathname === '/' ? '/home' : pathname;
  return {
    ...metadata,
    canonicalPath,
    canonicalUrl: absoluteUrl(canonicalPath),
    image: absoluteUrl(metadata.image || DEFAULT_IMAGE_PATH),
    robots: metadata.robots || 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
    type: metadata.type || 'website',
    statusCode: metadata.statusCode || 200,
  };
}

function getPageMetadata(pathname, products = [], categories = []) {
  const path = normalizePathname(pathname);
  const staticPath = path === '/' ? '/home' : path;

  if (STATIC_PAGE_METADATA[staticPath]) {
    return buildBasePage(path, STATIC_PAGE_METADATA[staticPath]);
  }

  if (path === '/vehicles/compare') {
    return buildBasePage(path, {
      title: `Compare Rental Vehicles | ${SITE_NAME}`,
      description: 'Compare selected DeRoyalty rental vehicles, daily rates and features.',
      breadcrumb: 'Compare Vehicles',
      robots: 'noindex,follow',
    });
  }

  const vehicleMatch = path.match(/^\/vehicle\/show\/(\d+)(?:\/.*)?$/);
  if (vehicleMatch) {
    const product = findProduct(products, vehicleMatch[1]);
    if (!product) {
      return buildBasePage(path, {
        title: Array.isArray(products) && products.length
          ? `Vehicle Not Found | ${SITE_NAME}`
          : `Rental Vehicle | ${SITE_NAME}`,
        description: Array.isArray(products) && products.length
          ? 'The requested DeRoyalty rental vehicle could not be found.'
          : 'View vehicle details, daily rental pricing, availability and booking requirements from DeRoyalty Car Rental.',
        breadcrumb: Array.isArray(products) && products.length ? 'Vehicle Not Found' : 'Vehicle',
        ...(Array.isArray(products) && products.length
          ? { robots: 'noindex,nofollow,noarchive', statusCode: 404 }
          : {}),
      });
    }

    const categoryName = product.categoryName || getCategoryName(product.category) || 'Rental Vehicle';
    const price = Number(product.price);
    const rate = Number.isFinite(price) ? ` from US$${price.toLocaleString('en-US')}/day` : '';
    const canonicalPath = canonicalVehiclePath(product);

    return buildBasePage(canonicalPath, {
      title: `${product.name} Hire in Harare | DeRoyalty`,
      description: `${product.name} ${categoryName.toLowerCase()} hire in Harare${rate}. View features, availability, requirements and booking details.`,
      breadcrumb: product.name,
      image: product.imageURL || DEFAULT_IMAGE_PATH,
      type: 'product',
      product,
    });
  }

  const categoryMatch = path.match(/^\/category\/show\/(\d+)$/);
  if (categoryMatch) {
    const category = findCategory(categories, categoryMatch[1]);
    const categoryName = getCategoryName(category);
    if (!category) {
      return buildBasePage(path, {
        title: Array.isArray(categories) && categories.length
          ? `Vehicle Category Not Found | ${SITE_NAME}`
          : `Rental Vehicle Category | ${SITE_NAME}`,
        description: Array.isArray(categories) && categories.length
          ? 'The requested DeRoyalty rental vehicle category could not be found.'
          : 'Browse DeRoyalty vehicle rental categories and available car hire options in Harare.',
        breadcrumb: Array.isArray(categories) && categories.length ? 'Category Not Found' : 'Vehicle Category',
        ...(Array.isArray(categories) && categories.length
          ? { robots: 'noindex,nofollow,noarchive', statusCode: 404 }
          : {}),
      });
    }

    return buildBasePage(path, {
      title: `${categoryName} Hire in Harare | DeRoyalty`,
      description: category.description || `Browse ${categoryName.toLowerCase()} rental options and daily hire rates from DeRoyalty Car Rental in Harare.`,
      breadcrumb: categoryName,
      image: category.imageURL || category.imageUrl || DEFAULT_IMAGE_PATH,
      category,
    });
  }

  if (NOINDEX_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return buildBasePage(path, {
      title: `Secure Customer Area | ${SITE_NAME}`,
      description: 'DeRoyalty Car Rental customer and administration area.',
      breadcrumb: 'Customer Area',
      robots: 'noindex,nofollow,noarchive',
    });
  }

  return buildBasePage(path, {
    title: `Page Not Found | ${SITE_NAME}`,
    description: 'The requested DeRoyalty Car Rental page could not be found.',
    breadcrumb: 'Page Not Found',
    robots: 'noindex,nofollow,noarchive',
    statusCode: 404,
  });
}

function buildBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'AutoRental',
    '@id': `${SITE_URL}/#business`,
    name: SITE_NAME,
    url: `${SITE_URL}/home`,
    logo: absoluteUrl('/web-logo.jpg'),
    image: absoluteUrl('/web-logo.jpg'),
    email: 'customercare@deroyaltycarrental.com',
    telephone: '+263712768037',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '2870 Mainway Meadows, Waterfalls',
      addressLocality: 'Harare',
      addressCountry: 'ZW',
    },
    areaServed: [
      { '@type': 'City', name: 'Harare' },
      { '@type': 'City', name: 'Bulawayo' },
      { '@type': 'Country', name: 'Zimbabwe' },
    ],
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '17:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '08:00',
        closes: '13:00',
      },
    ],
    sameAs: [INSTAGRAM_URL],
  };
}

function buildBreadcrumbSchema(page) {
  const items = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: absoluteUrl('/home'),
    },
  ];

  if (page.canonicalPath.startsWith('/vehicle/show/')) {
    items.push({
      '@type': 'ListItem',
      position: 2,
      name: 'Vehicles',
      item: absoluteUrl('/vehicles'),
    });
  }

  if (page.canonicalPath !== '/home') {
    items.push({
      '@type': 'ListItem',
      position: items.length + 1,
      name: page.breadcrumb,
      item: page.canonicalUrl,
    });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };
}

function buildVehicleSchema(page) {
  const product = page.product;
  if (!product) return null;

  const price = Number(product.price);
  const availability = String(product.bookingStatus || '').toLowerCase() === 'available'
    ? 'https://schema.org/InStock'
    : 'https://schema.org/OutOfStock';

  const offer = Number.isFinite(price) && price > 0
    ? {
        '@type': 'Offer',
        url: page.canonicalUrl,
        price,
        priceCurrency: 'USD',
        availability,
        businessFunction: 'http://purl.org/goodrelations/v1#LeaseOut',
        seller: { '@id': `${SITE_URL}/#business` },
        priceSpecification: {
          '@type': 'UnitPriceSpecification',
          price,
          priceCurrency: 'USD',
          unitCode: 'DAY',
        },
      }
    : undefined;

  return {
    '@context': 'https://schema.org',
    '@type': 'Vehicle',
    '@id': `${page.canonicalUrl}#vehicle`,
    name: product.name,
    url: page.canonicalUrl,
    image: absoluteUrl(product.imageURL || DEFAULT_IMAGE_PATH),
    description: product.description || page.description,
    vehicleModelDate: product.modelYear || product.year || undefined,
    vehicleConfiguration: product.categoryName || getCategoryName(product.category) || undefined,
    offers: offer,
  };
}

function buildStructuredData(page, products = []) {
  if (page.robots.startsWith('noindex') || page.statusCode >= 400) return [];

  const schemas = [buildBusinessSchema(), buildBreadcrumbSchema(page)];

  if (page.canonicalPath === '/home') {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: `${SITE_URL}/home`,
      name: SITE_NAME,
      publisher: { '@id': `${SITE_URL}/#business` },
      inLanguage: 'en-ZW',
    });
  }

  if (page.canonicalPath === '/about') {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: ABOUT_FAQS.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    });
  }

  if (page.canonicalPath === '/vehicles' && Array.isArray(products) && products.length) {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'DeRoyalty Car Rental Fleet',
      numberOfItems: products.length,
      itemListElement: products.map((product, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: product.name,
        url: absoluteUrl(canonicalVehiclePath(product)),
      })),
    });
  }

  const vehicleSchema = buildVehicleSchema(page);
  if (vehicleSchema) schemas.push(vehicleSchema);

  return schemas;
}

export {
  ABOUT_FAQS,
  DEFAULT_IMAGE_PATH,
  SITE_NAME,
  SITE_URL,
  STATIC_PAGE_METADATA,
  absoluteUrl,
  buildStructuredData,
  canonicalVehiclePath,
  getPageMetadata,
  normalizePathname,
};
